import React from 'react'
import { useCallback } from 'react'
import { format } from 'date-fns'
import DodoneEditModal from 'app/dodones/edit/Modal'

const formatDateTime = (date) => {
  return format(date, 'HH:mm')
}

export default ({ dodone }) => {
  const getDuration = useCallback(() => {
    const totalSeconds = Math.floor((dodone.finishedAt - dodone.startedAt) / 1000)

    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)

    if (hours > 0) {
      return `${hours}h${minutes}m`
    }

    return `${minutes}m`
  })

  return <div className="dodone-stats mb-d">
           <div className="dodone-stats-timeline">
             <DodoneEditModal attributeName="started_at">
               <div className="timeline-item">
                 <span className="timeline-label">Started</span>
                 <span className="timeline-value">{formatDateTime(dodone.startedAt)}</span>
               </div>
             </DodoneEditModal>

             <DodoneEditModal attributeName="finished_at">
               <div className="timeline-item">
                 <span className="timeline-label">Finished</span>
                 <span className="timeline-value">{formatDateTime(dodone.finishedAt)}</span>
               </div>
             </DodoneEditModal>
           </div>

           <div className="dodone-stats-duration">
             <span className="duration-label">Duration</span>
             <span className="duration-value">{getDuration()}</span>
           </div>
         </div>
}
